"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var firestore_1 = require("firebase/firestore");
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var react_redux_1 = require("react-redux");
var NeutralDivider_1 = __importDefault(require("atomicComponents/atoms/Divider/NeutralDivider"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var Text_1 = __importDefault(require("shared/components/Text"));
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var data_1 = require("utils/selectors/data");
var single_1 = require("utils/selectors/single");
var context_1 = require("../context");
var utils_1 = require("../utils");
var ExcludeIncludeModal_1 = __importDefault(require("./ExcludeIncludeModal"));
var BatchExcludeIncludeModal = function (_a) {
    var actionTarget = _a.actionTarget, clear = _a.clear, onClose = _a.onClose;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var rechVendorsMap = (0, react_redux_1.useSelector)(data_1.selectRechargedVendorsData);
    var _b = (0, context_1.useSelectedRecharges)(), selectedItems = _b.selectedItems, selectedIds = _b.selectedIds;
    var isRevert = selectedItems[0].isExcluded;
    var _c = __read((0, backend_1.useCall)('misc-excludeorganizationvendorscall', { isRevert: isRevert, companyId: profile.companyId }), 2), excludeOrgs = _c[0], isExcludingOrgs = _c[1];
    var excludedCharges = selectedItems.filter(function (r) { return r.isExcluded && !(0, utils_1.isExcludedOrg)(r); });
    var affectedChargeIds = isRevert ? excludedCharges.map(function (r) { return r.id; }) : selectedIds;
    var _d = __read((0, backend_1.useCall)('misc-excluderecharges', {
        isRevert: isRevert,
        companyId: profile.companyId, rechargeIds: affectedChargeIds,
    }), 2), excludeChargesCall = _d[0], isCallingExcludeCharges = _d[1];
    var _e = __read((0, hooks_1.useBatchSubmitter)('recharges', affectedChargeIds, { isExcluded: !isRevert, excludeReason: isRevert ? (0, firestore_1.deleteField)() : 'MANUAL' }), 2), batchExcludeCharges = _e[0], isExcludingCharges = _e[1];
    var excludeCharges = affectedChargeIds.length > 40
        ? excludeChargesCall()
        : function () { return batchExcludeCharges({ excludedOn: isRevert ? (0, firestore_1.deleteField)() : firestore_1.Timestamp.now() }); };
    var excludedOrgsVendors = (0, utils_1.getOrgVendors)(selectedItems
        .filter(function (r) { var _a; return r.rechVendorId && ((_a = r.rechargedOrganization.excludedVendors) === null || _a === void 0 ? void 0 : _a[r.rechVendorId]); }));
    var affectedOrgVendors = isRevert ? excludedOrgsVendors : (0, utils_1.getOrgVendors)(selectedItems);
    var action = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!actionTarget) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, Promise.all([
                            ['org', 'all'].includes(actionTarget) && excludeOrgs({ orgVendors: affectedOrgVendors.filter(utils_1.hasVendor) })(),
                            ['charge', 'all'].includes(actionTarget) && excludeCharges(),
                        ].filter(end2end_1.notFalsy))];
                case 1:
                    _a.sent();
                    clear();
                    return [2 /*return*/];
            }
        });
    }); };
    var vendorsCount = Object.entries((0, groupBy_1.default)(affectedOrgVendors, 'rechVendorId'))
        .map(function (_a) {
        var _b = __read(_a, 2), vendorId = _b[0], orgVendors = _b[1];
        return ({ rechVendor: rechVendorsMap === null || rechVendorsMap === void 0 ? void 0 : rechVendorsMap[vendorId], vendorId: vendorId, count: orgVendors.length });
    });
    var isSending = isExcludingCharges || isExcludingOrgs || isCallingExcludeCharges;
    return ((0, jsx_runtime_1.jsxs)(ExcludeIncludeModal_1.default, __assign({ open: !!actionTarget, actionType: isRevert ? 'include' : 'exclude', onClose: onClose, title: actionTarget !== 'all'
            ? "Would you like to ".concat(isRevert ? 'include' : 'exclude', " these ").concat(actionTarget === 'charge' ? 'charges' : 'organisations', "?")
            : 'Confirm reverting these exclusions', isSending: isSending, buttonAction: action }, { children: [!isRevert && actionTarget === 'charge' && ("These ".concat(selectedItems.length, " charges will not be included in the next invoice. You can always revert this.")), isRevert && actionTarget === 'charge' && 'These charges will be included in the next invoice.', isRevert && actionTarget === 'all' && 'All these charges will be included in the next invoices.', actionTarget === 'org' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isRevert
                    // eslint-disable-next-line max-len
                    ? 'All existing charges linked to these organisation will be included in the next invoice. To exclude older charges, do it manually using the filters'
                    : 'Any existing or future charges imported for this organisations and vendors will be ignored. You can always revert this.' })), actionTarget !== 'charge' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ py: 2 }, { children: (0, jsx_runtime_1.jsx)(NeutralDivider_1.default, {}) })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, fontWeight: 600, textAlign: "left" }, { children: ["Exclusions ", isRevert && 'to be reverted:'] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ component: "ul", textAlign: "left", pt: 2 }, { children: [actionTarget === 'all' && ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "li", pb: 2.5 }, { children: (0, end2end_1.handlePlural)('charge')((isRevert ? excludedCharges : selectedItems).length) }))), vendorsCount === null || vendorsCount === void 0 ? void 0 : vendorsCount.map(function (vendorCount) {
                                var _a;
                                return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ component: "li", pb: 2.5 }, { children: [(0, end2end_1.handlePlural)('organisation')(vendorCount.count), " from ", ' ', (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "inline-block", component: "span", sx: { verticalAlign: 'bottom', span: { color: 'riverstone' } } }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: (_a = vendorCount.rechVendor) !== null && _a !== void 0 ? _a : { name: 'No vendor' }, size: "sm_plus" }) }))] }), vendorCount.vendorId));
                            })] }))] }))] })));
};
exports.default = BatchExcludeIncludeModal;
